import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Mobile variant for the Pagination component.
 */
import { useCallback } from 'react';
import { Box, IconButton, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { BxChevronLeft, BxChevronRight } from '../icons';
export const PaginationMinimal = ({ pageSize, onPageChange, totalCount, currentPage, isDisabled, }) => {
    const styles = useMultiStyleConfig('Pagination', { variant: 'minimal' });
    const totalPageCount = Math.ceil(totalCount / pageSize);
    const isDisableNextPage = isDisabled || currentPage >= totalPageCount;
    const isDisablePrevPage = isDisabled || currentPage <= 1;
    const handlePageBack = useCallback(() => {
        if (isDisablePrevPage)
            return;
        onPageChange(currentPage - 1);
    }, [currentPage, isDisablePrevPage, onPageChange]);
    const handlePageNext = useCallback(() => {
        if (isDisableNextPage)
            return;
        onPageChange(currentPage + 1);
    }, [currentPage, isDisableNextPage, onPageChange]);
    return (_jsxs(Box, { __css: styles.container, children: [_jsx(IconButton, { variant: "unstyled", sx: styles.stepper, "aria-label": "Previous page", isDisabled: isDisablePrevPage, onClick: handlePageBack, icon: _jsx(BxChevronLeft, {}) }), _jsxs(Text, { sx: styles.text, "aria-disabled": isDisabled, children: ["Page ", currentPage, " of ", totalPageCount] }), _jsx(IconButton, { variant: "unstyled", sx: styles.stepper, "aria-label": "Next page", isDisabled: isDisableNextPage, onClick: handlePageNext, icon: _jsx(BxChevronRight, {}) })] }));
};
